import React, { useEffect,useState } from "react";
import { Box, Typography, Button, Grid, Card, CardMedia, CardContent } from "@mui/material";
import { useNavigate } from "react-router";
import { ArticleGetBatch, ResourceGet } from "../../api/orgService";
import useApi from "../../api/useApi";
import { toast } from "react-toastify";

// const resources = [
//   {
//     id: 1,
//     title: "IRC's Feelings Thermometer",
//     date: "September 4, 2025",
//     image: "https://picsum.photos/600/400?random=1",
//   },
//   {
//     id: 2,
//     title: "the next story again",
//     date: "August 21, 2025",
//     image: "https://picsum.photos/600/400?random=2",
//   },
//   {
//     id: 3,
//     title: "International Rescue Committee (IRC) in Ukraine",
//     date: "August 20, 2025",
//     image: "https://picsum.photos/600/400?random=3",
//   },
// ];

const ResourceList = ({subcategoryId}) => {
    const navigate = useNavigate()
    const [relatedArticles,setRelatedArticles]=useState([])

    const { request: getRelatedArticles, data:relatedArticlesData, error:relatedArticlesError,isLoading:getRelatedArticlesLoading} = useApi(ArticleGetBatch);
        
    useEffect(() => {
      if(subcategoryId){
      getRelatedArticles({subcategory:subcategoryId});
      }
            // eslint-disable-next-line
      }, [subcategoryId]);
      
      useEffect(()=>{
        if (relatedArticlesData?.status===200) {
          setRelatedArticles(relatedArticlesData?.data?.results);
        }
      // eslint-disable-next-line
      },[relatedArticlesData])

    
    //   // useEffect(()=>{
    //   //     if(location?.state?.refresh==="org"){
    //   //       getAllResources();
    //   //     }
    //   //   // eslint-disable-next-line
    //   //   },[location?.state])
    
      useEffect(()=>{
          if(relatedArticlesError){
              toast.error(`${JSON.stringify(relatedArticlesError?.response?.data,null,2)}`,{position: "top-center"});
        }
      },[relatedArticlesError]) 


  return (
    <Box sx={{ maxWidth: "1000px", mx: "auto", p: { xs: 2, md: 4 } }}>
      {
      relatedArticles?.length>0?(
        relatedArticles?.map((item, index) => (
        <Card
          key={item.id}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            mb: 3,
            boxShadow: "none",
            bgcolor: index % 2 === 0 ? "#f9f9f9" : "#efefef",
            borderRadius: 2,
            overflow: "hidden",
            "&:hover": { boxShadow: 6, transform: "scale(1.01)", transition: "0.3s" }
          }}
        >
          {/* Image Section */}
          <CardMedia
            component="img"
            sx={{
              width: { xs: "100%", sm: "40%" },
              height: { xs: 200, sm: "auto" },
              objectFit: "cover",
            }}
            image={item.img}
            alt={item.title}
          />

          {/* Text Section */}
          <CardContent
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              p: { xs: 2, sm: 3 },
            }}
          >
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {item.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {item.date}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                alignSelf: "flex-start",
                mt: 1,
                textTransform: "none",
                borderRadius: "20px",
              }}
              onClick={(e)=>{
                e.preventDefault()
                
                navigate(`/articles/${item?.title?.slice(0,20)}/${item?.id}/`,{state:{articleId: item?.id, articleName: item?.title}})
              }}
            >
              Read More
            </Button>
          </CardContent>
        </Card>
      ))):(
        <h3>No related articles</h3>
      )
    }
    </Box>
  );
};

export default ResourceList;
